import { Navigate, Route, Routes } from "react-router-dom";

import ProtectedRoutes from "@/routes/ProtectedRoutes";

import DashboardSelector from "@/pages/dashboardSelector";
import Login from "@/pages/login";
import VersionSelector from "@/pages/versionSelector";

function App() {
  return (
    <div data-testid="app-container">
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* declare here all private routes */}
        <Route element={<ProtectedRoutes />}>
          <Route path="/dashboard" element={<DashboardSelector />}>
            <Route path=":recordId/*" element={<DashboardSelector />}></Route>
          </Route>
          <Route path="/record">
            <Route path=":recordId/*" element={<VersionSelector />}></Route>
          </Route>
          <Route path="/" element={<DashboardSelector />} />
          <Route path="/roles" element={<DashboardSelector />}>
            <Route path="dashboard" element={<DashboardSelector />}></Route>
          </Route>
          <Route path="/*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
